
import { Collection, IAttribute, IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Named } from '../base/named';
import { ParameterValue } from '../base/parameter-value';
import { LinkedService } from '../linkedservice/linkedservice';

@Metamodel.model({
    name: 'logging-location'
})
export class LoggingLocation extends Named {
    public static readonly PATH: IAttribute;
    public static readonly LINKED_SERVICE_PARAMETERS: IAttribute;
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        reference: true
    })
    public storageLinkedService?: LinkedService;

    /**
     * Parameter value for referenced linked service.
     */
    @Metamodel.attribute({
        collection: Collection.Array,
        constraint: {
            required: false
        },
        association: 'LINKED_SERVICE_PARAMETERS'
    })
    public linkedServiceParameters?: ParameterValue[] = [];

    @Metamodel.attribute({
        display: stringResources.StagingSetting_PathLabel,
        templatable: true,
        association: 'PATH'
    })
    public path?: string;
}
